import { render, staticRenderFns } from "./ServiceIntendedDatagrid.vue?vue&type=template&id=51dc83ec&scoped=true&"
import script from "./ServiceIntendedDatagrid.vue?vue&type=script&lang=js&"
export * from "./ServiceIntendedDatagrid.vue?vue&type=script&lang=js&"
import style0 from "./ServiceIntendedDatagrid.vue?vue&type=style&index=0&id=51dc83ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dc83ec",
  null
  
)

export default component.exports